import { render, staticRenderFns } from "./ProfiloAtleta.vue?vue&type=template&id=1e23b2b7&scoped=true&"
import script from "./ProfiloAtleta.vue?vue&type=script&lang=js&"
export * from "./ProfiloAtleta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e23b2b7",
  null
  
)

export default component.exports